OnCloudCollapse =
{
	init: function()
	{
		if( jQuery( '[data-oc-id="oc-collapse"]' ).size() == 0 )
		{
			return false;
		}
		
		OnCloudCollapse.init_ui();
	}
	,
	init_ui: function()
	{
		jQuery('[data-oc-id="oc-collapse"]').each(function(pm_index){
			var collapse = jQuery(this);
			var title = jQuery(this).find('.oc-collapse-title');
			var toggle = title.find('.toggle');
			var content = jQuery(this).find('.oc-collapse-content');
			
			toggle.on('click', function(event){
				
				if( collapse.hasClass('open') )
				{
					content.slideUp('fast',function(){
						collapse.removeClass('open');
					});
				}
				else
				{
					content.slideDown('fast',function(){
						collapse.addClass('open');
					});
				}
				
				event.preventDefault();
			});
		});
	}
};//end object literal VideoNotices

jQuery(document).ready(function(jQuery){
	
	OnCloudCollapse.init();
	
});
